const appConstants = {
    responseMessages: {
        users: {
            loginSuccess: 'Login Success',
            loginFailed: 'Login Failed',
            registrationSuccess: 'registrationSuccess',
            registrationFailed: 'registrationFailed',
        },
    },
};

export default appConstants;